export enum NOTIFICATIONS_CENTER {
    /**
     * @value %AUTHOR_NAME% published a new article in <strong>%COMMUNITY_NAME%</strong>: <strong>%CONTENT_TITLE%</strong>.
     */
    ARTICLE_NEW = 'NOTIFICATIONS_CENTER.ARTICLE_NEW',
    /**
     * @value All notifications will be permanently deleted.
     * @description when the user wants to delete all his notifications this message is displayed in a confirmation dialog inviting the user to cancel or confirm.
     */
    CLEAR_ALL_CONFIRM_DESCRIPTION = 'FRONT.NOTIFICATIONS.CLEAR_ALL.CONFIRM_DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% mentioned you in a comment on <strong>%CONTENT_TITLE%</strong> in <strong>%COMMUNITY_NAME%</strong>.
     */
    COMMENT_MENTION = 'NOTIFICATIONS_CENTER.COMMENT_MENTION',
    /**
     * @value {"one":"%AUTHOR_NAME% and 1 other mentioned you in a comment on <strong>%CONTENT_TITLE%<\/strong> in <strong>%COMMUNITY_NAME%<\/strong>.","other":"%AUTHOR_NAME% and %NB_OTHERS% others mentioned you in a comment on <strong>%CONTENT_TITLE%<\/strong> in <strong>%COMMUNITY_NAME%<\/strong>."}
     * @description Notification text saying more than 1 person mentionned you in in a comment in a post of a community, showing the name of the first one.
     */
    COMMENT_MENTION_MULTIPLE = 'NOTIFICATION.COMMENT.POST.MENTION.DESCRIPTION_OTHERS',
    /**
     * @value %AUTHOR_NAME% mentioned you in a comment on an event in <strong>%COMMUNITY_NAME%</strong>.
     */
    COMMENT_MENTION_WITHOUT_TITLE = 'NOTIFICATIONS_CENTER.COMMENT_EVENT_MENTION_WITHOUT_TITLE_DESCRIPTION',
    /**
     * @value Your comment on <strong>%CONTENT_TITLE%</strong> has been unpublished following a report. Contact an admin for more information.
     */
    COMMENT_REPORT_ACCEPTED_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_ACCEPTED_DESCRIPTION',
    /**
     * @value Your comment on a post from the community <strong>%COMMUNITY_NAME%</strong> has been unpublished following a report. Contact an admin for more information.
     */
    COMMENT_REPORT_ACCEPTED_POST_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_ACCEPTED_POST_DESCRIPTION',
    /**
     * @value Your comment on the post <strong>%POST_TITLE%</strong> from the community <strong>%COMMUNITY_NAME%</strong> has been unpublished following a report. Contact an admin for more information.
     */
    COMMENT_REPORT_ACCEPTED_POST_WITH_TITLE_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_ACCEPTED_POST_WITH_TITLE_DESCRIPTION',
    /**
     * @value A comment on <strong>%CONTENT_TITLE%</strong> has been reported by %LAST_REPORTER_NAME% and %NB_OTHER_REPORTS% other people.
     */
    COMMENT_REPORT_CREATED_MORE_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_CREATED_MORE_DESCRIPTION',
    /**
     * @value A comment on <strong>%CONTENT_TITLE%</strong> has been reported by %LAST_REPORTER_NAME%.
     */
    COMMENT_REPORT_CREATED_ONE_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_CREATED_ONE_DESCRIPTION',
    /**
     * @value A comment on a post from the community <strong>%COMMUNITY_NAME%</strong> has been reported by %LAST_REPORTER_NAME% and %NB_OTHER_REPORTS% other people.
     */
    COMMENT_REPORT_CREATED_POST_MORE_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_CREATED_POST_MORE_DESCRIPTION',
    /**
     * @value A comment on a post from the community <strong>%COMMUNITY_NAME%</strong> has been reported by %LAST_REPORTER_NAME%.
     */
    COMMENT_REPORT_CREATED_POST_ONE_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_CREATED_POST_ONE_DESCRIPTION',
    /**
     * @value A comment on the post <strong>%POST_TITLE%</strong> from the community <strong>%COMMUNITY_NAME%</strong> has been reported by %LAST_REPORTER_NAME% and %NB_OTHER_REPORTS% other people.
     */
    COMMENT_REPORT_CREATED_POST_WITH_TITLE_MORE_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_CREATED_POST_WITH_TITLE_MORE_DESCRIPTION',
    /**
     * @value A comment on the post <strong>%POST_TITLE%</strong> from the community <strong>%COMMUNITY_NAME%</strong> has been reported by %LAST_REPORTER_NAME%.
     */
    COMMENT_REPORT_CREATED_POST_WITH_TITLE_ONE_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_CREATED_POST_WITH_TITLE_ONE_DESCRIPTION',
    /**
     * @value Your report regarding a comment on <strong>%CONTENT_TITLE%</strong> has been processed.
     */
    COMMENT_REPORT_REVIEWED_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_REVIEWED_DESCRIPTION',
    /**
     * @value Your report regarding a comment on a post in the community <strong>%COMMUNITY_NAME%</strong> has been processed.
     */
    COMMENT_REPORT_REVIEWED_POST_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_REVIEWED_POST_DESCRIPTION',
    /**
     * @value Your report regarding a comment on the post <strong>%POST_TITLE%</strong> in the community <strong>%COMMUNITY_NAME%</strong> has been processed.
     */
    COMMENT_REPORT_REVIEWED_POST_WITH_TITLE_DESCRIPTION = 'NOTIFICATION.COMMENT_REPORT_REVIEWED_POST_WITH_TITLE_DESCRIPTION',
    /**
     * @value <strong>%COMMUNITY_TITLE%</strong> %COMMUNITY_DESC%
     */
    COMMUNITY_EXTENDED_SERVICE_MANAGEMENT_DESCRIPTION = 'NOTIFICATION.COMMUNITY.EXTENDED.SERVICE.MANAGEMENT.DESCRIPTION',
    /**
     * @value You have %NB_REQUESTS% pending %ACCESS_REQUESTS% for <strong>%COMMUNITY_TITLE%</strong>.
     */
    COMMUNITY_NEW_ACCESS_REQUEST_DESCRIPTION = 'NOTIFICATION_COMMUNITY_NEW_ACCESS_REQUEST_DESCRIPTION',
    /**
     * @value You now have access to the <strong>%COMMUNITY_TITLE%</strong> community.
     */
    COMMUNITY_NEW_CREDENTIAL_DESCRIPTION = 'NOTIFICATION_COMMUNITY_NEW_CREDENTIAL_DESCRIPTION',
    /**
     * @value <strong>%CONTENT_TITLE%</strong> expires in %EXPIRATION_DATE%.
     */
    CONTENT_EXPIRATION_DESCRIPTION = 'NOTIFICATION_CONTENT_EXPIRATION_DESCRIPTION',
    /**
     * @value <strong>%CONTENT_TITLE%</strong> has expired.
     */
    CONTENT_EXPIRED_DESCRIPTION = 'NOTIFICATION.CONTENT.EXPIRED.DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% liked <strong>%CONTENT_TITLE%</strong>.
     * @description Notification description when a user is notify about a comment on a content
     */
    CONTENT_LIKE_DESCRIPTION = 'NOTIFICATION.CONTENT.LIKE.DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% mentioned you on <strong>%CONTENT_TITLE%</strong> in <strong>%SITE_NAME%</strong>.
     */
    CONTENT_MENTION_WITH_SITE_NAME = 'NOTIFICATIONS_CENTER.CONTENT_MENTION_WITH_SITE_NAME',
    /**
     * @value %AUTHOR_NAME% mentioned you on <strong>%CONTENT_TITLE%</strong> in <strong>%COMMUNITY_NAME%</strong>.
     */
    CONTENT_MENTION_WITH_TITLE_DESCRIPTION = 'NOTIFICATIONS_CENTER.CONTENT_MENTION_WITH_TITLE_DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% created new content: <strong>%CONTENT_TITLE%</strong>.
     */
    CONTENT_NEW_DESCRIPTION = 'NOTIFICATION.CONTENT.NEW.DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% liked <strong>%CONTENT_TITLE%</strong> in <strong>%COMMUNITY_NAME%</strong>.
     * @description Notification description when a user is notify about a comment on a content in a community
     */
    CONTENT_POST_LIKE_DESCRIPTION = 'NOTIFICATION.CONTENT.POST.LIKE.DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% liked a post in <strong>%COMMUNITY_NAME%</strong>.
     * @description Notification text mentionning someone liked a titleless post inside a community
     */
    CONTENT_POST_LIKE_WITHOUT_TITLE_DESCRIPTION = 'NOTIFICATION.CONTENT.POST.LIKE.WITHOUT.TITLE.DESCRIPTION',
    /**
     * @value <strong>%CONTENT_TITLE%</strong> has been rejected.
     */
    CONTENT_REFUSED_DESCRIPTION = 'NOTIFICATION_CONTENT_REFUSED_DESCRIPTION',
    /**
     * @value Your content <strong>%CONTENT_TITLE%</strong> has been unpublished following a report. Contact an admin for more information.
     * @description The notification description when a review on a reported content has been accepted.
     */
    CONTENT_REPORT_ACCEPTED_DESCRIPTION = 'NOTIFICATION.CONTENT_REPORT_ACCEPTED_DESCRIPTION',
    /**
     * @value Content <strong>%CONTENT_TITLE%</strong> has been reported by %LAST_REPORTER_NAME% and %NB_OTHER_REPORTS% other people.
     * @description The notification description when a content has been reported by more than one reporter.
     */
    CONTENT_REPORT_CREATED_MORE_DESCRIPTION = 'NOTIFICATION.CONTENT_REPORT_CREATED_MORE_DESCRIPTION',
    /**
     * @value Content <strong>%CONTENT_TITLE%</strong> has been reported by %LAST_REPORTER_NAME%.
     * @description The notification description when a content has been reported by one reporter.
     */
    CONTENT_REPORT_CREATED_ONE_DESCRIPTION = 'NOTIFICATION.CONTENT_REPORT_CREATED_ONE_DESCRIPTION',
    /**
     * @value Your report regarding <strong>%CONTENT_TITLE%</strong> has been processed.
     * @description The notification description when a review on a reported content has been processed.
     */
    CONTENT_REPORT_REVIEWED_DESCRIPTION = 'NOTIFICATION.CONTENT_REPORT_REVIEWED_DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% updated <strong>%CONTENT_TITLE%</strong>.
     */
    CONTENT_UPDATE_DESCRIPTION = 'NOTIFICATION_CONTENT_UPDATE_DESCRIPTION',
    /**
     * @value <strong>%CONTENT_TITLE%</strong> has been validated.
     */
    CONTENT_VALIDATED_DESCRIPTION = 'NOTIFICATION_CONTENT_VALIDATED_DESCRIPTION',
    /**
     * @value You have a validation request pending for <strong>%CONTENT_TITLE%</strong>.
     */
    CONTENT_WORKFLOW_DESCRIPTION = 'NOTIFICATION_CONTENT_WORKFLOW_DESCRIPTION',
    /**
     * @value Delete all notifications
     * @description Title of the confirmation dialog asking the user to confirm that they definitely want to delete all their existing notifications
     */
    DELETE_ALL_DIALOG_TITLE = 'FRONT.NOTIFICATIONS.DELETE_ALL.DIALOG.TITLE',
    /**
     * @value All notifications deleted.
     * @description success message in a toast when the notifications deletion was successful.
     */
    DELETE_ALL_SUCCESS = 'FRONT.NOTIFICATIONS.DELETE_ALL.SUCCESS',
    /**
     * @value Check back later for new activity and updates.
     * @description Message to indicate there's no notifications activity
     */
    EMPTY_NOTIFICATIONS_MESSAGE = 'NOTIFICATIONS_CENTER.EMPTY_NOTIFICATIONS_MESSAGE',
    /**
     * @value %AUTHOR_NAME% updated the <strong>%EVENT_TITLE%</strong> event
     * @description Notification description when someone updates an event you are invited to.
     */
    EVENTS_UPDATED = 'NOTIFICATION.EVENTS_UPDATED',
    /**
     * @value %AUTHOR_NAME% invited you to an event <strong>%EVENT_TITLE%</strong>.
     * @description Notification description when someone invites you to an event.
     */
    EVENT_INVITATION_CREATED = 'NOTIFICATION.EVENT_INVITATION_CREATED',
    /**
     * @value %AUTHOR_NAME% published a new event in <strong>%COMMUNITY_NAME%</strong>: <strong>%CONTENT_TITLE%</strong>.
     */
    EVENT_NEW = 'NOTIFICATIONS_CENTER.EVENT_NEW',
    /**
     * @value %AUTHOR_NAME% published a new event in <strong>%COMMUNITY_NAME%</strong>.
     */
    EVENT_NEW_WITHOUT_TITLE = 'NOTIFICATIONS_CENTER.EVENT_NEW_WITHOUT_TITLE',
    /**
     * @value %AUTHOR_NAME% requested your approval to the event %EVENT_TITLE%
     */
    EVENT_REQUEST_APROVAL = 'NOTIFICATIONS_CENTER.EVENT_REQUEST_APROVAL',
    /**
     * @value %AUTHOR_NAME% + %NB_GUESTS% users requested your approval to an event and are waiting for your answer
     */
    EVENT_REQUEST_MULTIPLE = 'NOTIFICATIONS_CENTER.EVENT_REQUEST_MULTIPLE',
    /**
     * @value %AUTHOR_NAME% declined your request to the event <strong>%CONTENT_TITLE%</strong>
     */
    EVENT_REQUEST_RESPONSE_NEGATIVE = 'NOTIFICATIONS_CENTER.EVENT_REQUEST_RESPONSE_NEGATIVE',
    /**
     * @value %AUTHOR_NAME% declined your request to an event with the following message: "%REASON%"
     */
    EVENT_REQUEST_RESPONSE_NEGATIVE_WITH_REASON = 'NOTIFICATIONS_CENTER.EVENT_REQUEST_RESPONSE_NEGATIVE_WITH_REASON',
    /**
     * @value %AUTHOR_NAME% approved your request to the event <strong>%EVENT_TITLE%</strong>
     */
    EVENT_REQUEST_RESPONSE_POSITIVE = 'NOTIFICATIONS_CENTER.EVENT_REQUEST_POSITIVE_RESPONSE',
    /**
     * @value %AUTHOR_NAME% approved your request to an event with the following message: "%REASON%"
     */
    EVENT_REQUEST_RESPONSE_POSITIVE_WITH_REASON = 'NOTIFICATIONS_CENTER.EVENT_REQUEST_RESPONSE_POSITIVE_WITH_REASON',
    /**
     * @value %AUTHOR_NAME% requested your approval to an event and is waiting for your answer
     */
    EVENT_REQUEST_SINGLE = 'NOTIFICATIONS_CENTER.EVENT_REQUEST_SINGLE',
    /**
     * @value %AUTHOR_NAME% updated an event: <strong>%EVENT_TITLE%</strong>.
     * @description Notification description when someone updates an event you are invited to.
     */
    EVENT_UPDATED = 'NOTIFICATION.EVENT_UPDATED',
    /**
     * @value All
     * @description Filter to display 'All' the notifications (both read and unread notifications)
     */
    FILTER_ALL = 'FRONT.NOTIFICATIONS.FILTER.ALL',
    /**
     * @value Notification filters
     * @description Aria label for accessibility that explains what the group of two filters are about.
     */
    FILTER_GROUP_ARIA = 'FRONT.NOTIFICATIONS.FILTER_GROUP.ARIA',
    /**
     * @value Unread
     * @description Filter chip that lets users filter the notifications in order to display only the unread ones.
     */
    FILTER_UNREAD = 'FRONT.NOTIFICATIONS.FILTER.UNREAD',
    /**
     * @value %AUTHOR_NAME% congratulated you on completing <strong>%LEARNING_TITLE%</strong> training.
     * @description This key is used in a notification (like Facebook notification), AUTHOR_NAME is the person who sent a congratulation to someone about a training course which name is LEARNING_TITLE
     */
    LEARNING_CONGRATULATION = 'NOTIFICATIONS_CENTER.LEARNING_CONGRATULATION',
    /**
     * @value You have been enrolled to the required training <strong>%LEARNING_TITLE%</strong>
     */
    LEARNING_COURSE_BEGINNING = 'NOTIFICATIONS_CENTER.LEARNING_COURSE_BEGINNING',
    /**
     * @value You have 7 days to complete the required training <strong>%LEARNING_TITLE%</strong>
     */
    LEARNING_COURSE_ENDING_SOON = 'NOTIFICATIONS_CENTER.LEARNING_COURSE_ENDING_SOON',
    /**
     * @value This is your last day to complete the required training <strong>%LEARNING_TITLE%</strong>
     */
    LEARNING_COURSE_ENDING_TODAY = 'NOTIFICATIONS_CENTER.LEARNING_COURSE_ENDING_TODAY',
    /**
     * @value You are challenged by %AUTHOR_NAME%!
     * "%CHALLENGER_MESSAGE%"
     */
    LEARNING_DUEL = 'NOTIFICATIONS_CENTER.LEARNING_DUEL',
    /**
     * @value You are challenged by %AUTHOR_NAME%!
     * I bet you can't beat me in this quiz!
     */
    LEARNING_DUEL_DEFAULT = 'NOTIFICATIONS_CENTER.LEARNING_DUEL_DEFAULT',
    /**
     * @value %AUTHOR_NAME% reminded you to finish <strong>%LEARNING_TITLE%</strong>. Just a few steps left to your success!
     * @description This key is used in a notification (like Facebook notification), AUTHOR_NAME is the person who sent a reminder to someone about a training course which name is LEARNING_TITLE
     */
    LEARNING_REMINDER = 'NOTIFICATIONS_CENTER.LEARNING_REMINDER',
    /**
     * @value Mark all as read
     * @description A menu entry to mark all the notifications as read
     */
    MARK_ALL_AS_READ = 'FRONT.NOTIFICATIONS.MARK_ALL_AS_READ',
    /**
     * @value All Notifications marked as read.
     * @description Notice that all has been marked as read correctly
     */
    MARK_ALL_AS_READ_SUCCESS = 'FRONT.NOTIFICATIONS.MARK_ALL_AS_READ.SUCCESS',
    /**
     * @value Mark as read
     * @description Menu entry to mark a notificatin as read
     */
    MARK_AS_READ = 'NOTIFICATIONS.MARK_AS_READ',
    /**
     * @value Mark as unread
     * @description Menu entry to mark a notificatin as unread
     */
    MARK_AS_UNREAD = 'NOTIFICATIONS.MARK_AS_UNREAD',
    /**
     * @value More than %COUNT% notifications unread
     */
    MORE_THAN_X_NOTIFICATIONS_UNREAD = 'NOTIFICATIONS.MORE_THAN_X_NOTIFICATIONS_UNREAD',
    /**
     * @value Notifications
     * @description Notifications text
     */
    NOTIFICATIONS = 'NOTIFICATIONS',
    /**
     * @value Notifications settings
     */
    NOTIFICATIONS_SETTINGS = 'NOTIFICATIONS_SETTINGS',
    /**
     * @value No new notifications
     * @description Label of an empty state to let the user know she didn't receive any new notification since last time she checked.
     */
    NO_NEW_NOTIFICATION = 'FRONT.NOTIFICATIONS.NO_NEW_NOTIFICATION',
    /**
     * @value No unread notifications
     */
    NO_UNREAD_NOTIFICATIONS = 'NOTIFICATIONS.NO_UNREAD_NOTIFICATIONS',
    /**
     * @value %AUTHOR_NAME% mentioned you on a post in <strong>%COMMUNITY_NAME%</strong>.
     * @description Notification text saying 1 person mentionned you in a titleless post of a community
     */
    POST_MENTION_WITHOUT_TITLE_DESCRIPTION = 'NOTIFICATION.POST.MENTION.WITHOUT.TITLE.DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% mentioned you on <strong>%POST_TITLE%</strong> in <strong>%COMMUNITY_NAME%</strong>.
     * @description Notification text saying 1 person mentionned you in a post of a community
     */
    POST_MENTION_WITH_TITLE_DESCRIPTION = 'NOTIFICATION.POST.MENTION.WITH.TITLE.DESCRIPTION',
    /**
     * @value Reported post <strong>%POST_TITLE%</strong> has not been judged as undesirable.
     */
    POST_MODERATION_DECLINE_DESCRIPTION = 'NOTIFICATION_POST_MODERATION_DECLINE_DESCRIPTION',
    /**
     * @value A post you reported in <strong>%COMMUNITY_NAME%</strong> and <strong>%REPORT_COUNT%</strong> other posts have been deleted.
     */
    POST_MODERATION_DELETE_MORE_DESCRIPTION = 'NOTIFICATION_POST_MODERATION_DELETE_MORE_DESCRIPTION',
    /**
     * @value A post you reported in <strong>%COMMUNITY_NAME%</strong> has been deleted.
     */
    POST_MODERATION_DELETE_ONE_DESCRIPTION = 'NOTIFICATION_POST_MODERATION_DELETE_ONE_DESCRIPTION',
    /**
     * @value A post you posted in <strong>%COMMUNITY_NAME%</strong> has been deleted by moderator.
     */
    POST_MODERATION_DELETE_SPAMMER_DESCRIPTION = 'NOTIFICATION_POST_MODERATION_DELETE_SPAMMER_DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% wrote a new post in <strong>%COMMUNITY_TITLE%</strong>.
     */
    POST_NEW_DESCRIPTION = 'NOTIFICATION_POST_NEW_DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% created <strong>%POST_TITLE%</strong> in <strong>%COMMUNITY_TITLE%</strong>.
     * @description Notification reveived when a new post is created in a followed community.
     */
    POST_NEW_WITH_TITLE_DESCRIPTION = 'NOTIFICATION.POST.NEW.WITH.TITLE.DESCRIPTION',
    /**
     * @value Your post from the community <strong>%COMMUNITY_NAME%</strong> has been deleted following a report. Contact an admin for more information.
     * @description The notification description when a review on a post without title has been accepted.
     */
    POST_REPORT_ACCEPTED_DESCRIPTION = 'NOTIFICATION.POST_REPORT_ACCEPTED_DESCRIPTION',
    /**
     * @value Your post <strong>%POST_TITLE%</strong> from the community <strong>%COMMUNITY_NAME%</strong> has been deleted following a report. Contact an admin for more information.
     * @description The notification description when a review on a post with title has been accepted.
     */
    POST_REPORT_ACCEPTED_WITH_TITLE_DESCRIPTION = 'NOTIFICATION.POST_REPORT_ACCEPTED_WITH_TITLE_DESCRIPTION',
    /**
     * @value A post from the community <strong>%COMMUNITY_NAME%</strong> has been reported by %LAST_REPORTER_NAME% and %NB_OTHER_REPORTS% other people.
     * @description The notification description when a post without title has been reported by more than one reporter
     */
    POST_REPORT_CREATED_MORE_DESCRIPTION = 'NOTIFICATION.POST_REPORT_CREATED_MORE_DESCRIPTION',
    /**
     * @value A post from the community <strong>%COMMUNITY_NAME%</strong> has been reported by %LAST_REPORTER_NAME%.
     * @description The notification description when a post without title has been reported by one reporter.
     */
    POST_REPORT_CREATED_ONE_DESCRIPTION = 'NOTIFICATION.POST_REPORT_CREATED_ONE_DESCRIPTION',
    /**
     * @value Post <strong>%POST_TITLE%</strong> from the community <strong>%COMMUNITY_NAME%</strong> has been reported by %LAST_REPORTER_NAME% and %NB_OTHER_REPORTS% other people.
     * @description The notification description when a post with title has been reported by more than one reporter.
     */
    POST_REPORT_CREATED_WITH_TITLE_MORE_DESCRIPTION = 'NOTIFICATION.POST_REPORT_CREATED_WITH_TITLE_MORE_DESCRIPTION',
    /**
     * @value Post <strong>%POST_TITLE%</strong> from the community <strong>%COMMUNITY_NAME%</strong> has been reported by %LAST_REPORTER_NAME%.
     * @description The notification description when a post with title has been reported by one reporter.
     */
    POST_REPORT_CREATED_WITH_TITLE_ONE_DESCRIPTION = 'NOTIFICATION.POST_REPORT_CREATED_WITH_TITLE_ONE_DESCRIPTION',
    /**
     * @value Post <strong>%POST_TITLE%</strong> from <strong>%COMMUNITY_NAME%</strong> has been reported (%REPORT_COUNT%) as undesirable.
     */
    POST_REPORT_NEW_DESCRIPTION = 'NOTIFICATION_POST_REPORT_NEW_DESCRIPTION',
    /**
     * @value Your report regarding a post in the community <strong>%COMMUNITY_NAME%</strong> has been processed.
     * @description The notification description when a review on a post without title has been processed
     */
    POST_REPORT_REVIEWED_DESCRIPTION = 'NOTIFICATION.POST_REPORT_REVIEWED_DESCRIPTION',
    /**
     * @value Your report regarding the post <strong>%POST_TITLE%</strong> in the community <strong>%COMMUNITY_NAME%</strong> has been processed.
     * @description The notification description when a review on a post with title has been processed.
     */
    POST_REPORT_REVIEWED_WITH_TITLE_DESCRIPTION = 'NOTIFICATION.POST_REPORT_REVIEWED_WITH_TITLE_DESCRIPTION',
    /**
     * @value The status of your post was updated to <strong>%STATUS_NAME%</strong>.
     */
    POST_STATUS_UPDATE_DESCRIPTION = 'NOTIFICATION_POST_STATUS_UPDATE_DESCRIPTION',
    /**
     * @value The status of <strong>%POST_TITLE%</strong> was updated to <strong>%STATUS_NAME%</strong> in <strong>%COMMUNITY_TITLE%</strong>.
     * @description Notification received when a post from a followed community's status  is updated.
     */
    POST_STATUS_UPDATE_WITH_TITLE_DESCRIPTION = 'NOTIFICATION.POST.STATUS.UPDATE.WITH.TITLE.DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% updated a post in <strong>%COMMUNITY_TITLE%</strong>.
     */
    POST_UPDATE_DESCRIPTION = 'NOTIFICATION_POST_UPDATE_DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% updated <strong>%POST_TITLE%</strong> in <strong>%COMMUNITY_TITLE%</strong>.
     * @description Notification received when a post from a followed community is updated.
     */
    POST_UPDATE_WITH_TITLE_DESCRIPTION = 'NOTIFICATION.POST.UPDATE.WITH.TITLE.DESCRIPTION',
    /**
     * @value %AUTHOR_NAME% %REACTED_TO% <strong>%CONTENT_TITLE%</strong>.
     * @description This key is used to display a notification label showing the last personne who's reaction has been recorded on a content. The pluralization is dealt with by %REACTED_TO% that should be either [%key_id:651187998%](reacted to) or [%key_id:651844891%](and X other(s) reacted to) when more than one user reacted.
     *
     * Example: Jon and two others user reacted to a MY-CONTENT, the key should display in english "Jon and 2 others reacted to MY-CONTENT"
     */
    REACTION = 'NOTIFICATION.REACTION',
    /**
     * @value %AUTHOR_NAME% %REACTED_TO% your comment on <strong>%CONTENT_TITLE%</strong>.
     * @description This key is used to display a notification label showing the last personne who's reaction has been recorded on a comment in a content. The pluralization is dealt with by %REACTED_TO% that should be either [%key_id:651187998%](reacted to) or [%key_id:651844891%](and X other(s) reacted to) when more than one user reacted.
     *
     * Example: Jon and two others user reacted to a comment on MY-CONTENT, the key should display in english "Jon and 2 others reacted to your comment on MY-CONTENT"
     */
    REACTION_CONTENT_COMMENT = 'NOTIFICATION.REACTION_CONTENT_COMMENT',
    /**
     * @value %AUTHOR_NAME% %REACTED_TO% <strong>%POST_TITLE%</strong> in <strong>%COMMUNITY_NAME%</strong>.
     * @description This key is used to display a notification label showing the last personne who's reaction has been recorded on a post. The pluralization is dealt with by %REACTED_TO% that should be either [%key_id:651187998%](reacted to) or [%key_id:651844891%](and X other(s) reacted to) when more than one user reacted.
     *
     * Example: Jon and two others user reacted to a post MY-POST in MY-SPACE space, the key should display in english "Jon and 2 others reacted to MY-POST on MY-SPACE"
     */
    REACTION_POST = 'NOTIFICATION.REACTION_POST',
    /**
     * @value %AUTHOR_NAME% %REACTED_TO% your comment on <strong>%POST_TITLE%</strong> in <strong>%COMMUNITY_NAME%</strong>.
     * @description This key is used to display a notification label showing the last personne who's reaction has been recorded on a comment in a post. The pluralization is dealt with by %REACTED_TO% that should be either [%key_id:651187998%](reacted to) or [%key_id:651844891%](and X other(s) reacted to) when more than one user reacted.
     *
     * Example: Jon and two others user reacted to a comment on a post: MY-POST in MY-SPACE sapce, the key should display in english "Jon and 2 others reacted to your comment on MY-POST in MY-SPACE"
     */
    REACTION_POST_COMMENT = 'NOTIFICATION.REACTION_POST_COMMENT',
    /**
     * @value {"one":"reacted to","other":"reacted to"}
     */
    REACTION_REACTED_TO = 'GLOBAL.REACTED_TO',
    /**
     * @value {"one":"and %NB_OTHERS% other %REACTED_TO%","other":"and %NB_OTHERS% others %REACTED_TO%"}
     */
    REACTION_REACTED_TO_MULTI = 'NOTIFICATION.REACTION_REACTED_TO_MULTI',
    /**
     * @value New shareable content <strong>%CONTENT_TITLE%</strong> in <strong>%PROGRAM_NAME%</strong>.
     */
    SOCIAL_ADVOCACY_PROGRAMS_NEW_SHAREABLE_CONTENT_DESCRIPTION = 'NOTIFICATION.SOCIAL_ADVOCACY.PROGRAMS.NEW_SHAREABLE_CONTENT.DESCRIPTION',
    /**
     * @value New shareable image <strong>%CONTENT_TITLE%</strong> in <strong>%PROGRAM_NAME%</strong>.
     */
    SOCIAL_ADVOCACY_PROGRAMS_NEW_SHAREABLE_IMAGE_DESCRIPTION = 'NOTIFICATION.SOCIAL_ADVOCACY.PROGRAMS.NEW_SHAREABLE_IMAGE.DESCRIPTION',
    /**
     * @value You are now Ambassador on <strong>%PROGRAM_NAME%</strong>. Start sharing content.
     */
    SOCIAL_ADVOCACY_PROGRAMS_USER_PROMOTED_AMB_DESCRIPTION = 'NOTIFICATION.SOCIAL_ADVOCACY.PROGRAMS.USER_PROMOTED.AMB.DESCRIPTION',
    /**
     * @value You are now Program manager on <strong>%PROGRAM_NAME%</strong>. Start creating shareable content.
     */
    SOCIAL_ADVOCACY_PROGRAMS_USER_PROMOTED_POM_DESCRIPTION = 'NOTIFICATION.SOCIAL_ADVOCACY.PROGRAMS.USER_PROMOTED.POM.DESCRIPTION',
    /**
     * @value You are up to date
     */
    UP_TO_DATE = 'RECOMMENDATIONS.UP_TO_DATE',
    /**
     * @value %COUNT% unread notification
     */
    X_UNREAD_NOTIFICATION = 'NOTIFICATION.X_UNREAD_NOTIFICATION',
    /**
     * @value %COUNT% unread notifications
     */
    X_UNREAD_NOTIFICATIONS = 'NOTIFICATION.X_UNREAD_NOTIFICATIONS',
}
